module.exports = __webpack_public_path__ + "img/10.343482f7.jpg";